<template>
    <main class="flex min-h-screen w-full flex-col items-center bg-background px-4 pb-10 pt-20 md:pt-40">
        <div class="flex w-[36rem] max-w-full flex-col items-center gap-10">
            <VIcon
                name="logo"
                class="h-8 w-40 lg:w-60"
            />

            <div class="flex w-full flex-col gap-8 rounded-2xl bg-white p-8">
                <section
                    lang="fo"
                    class="flex flex-col gap-3"
                >
                    <h2>Vit eru skjótt aftur</h2>
                    <p>Økisnavn er í løtuni stongt vegna viðlíkahald. Takk fyri tolsemið.</p>
                </section>

                <hr class="border-black-50" />

                <section
                    lang="en"
                    class="flex flex-col gap-3"
                >
                    <h2>We'll be back soon</h2>
                    <p>Økisnavn is currently down for maintenance. Thank you for your patience.</p>
                </section>
            </div>
        </div>
    </main>
</template>
